// Importação de imagens para garantir que sempre funcionem
// Este arquivo centraliza todas as imagens do projeto

// Imagens principais
export const bannerDesktop = '/Imagens/banner-desktop.webp';
export const vehiclesAndBattery = '/Imagens/vehicles-and-battery.webp';

// Imagens das dobras
export const dobra1Desktop = '/Imagens/1_dobra_desk.jpg';
export const dobra1Mobile = '/Imagens/1_dobra_mobile.jpg';
export const dobra2Desktop = '/Imagens/2_dobra_desk.jpg';
export const dobra2Mobile = '/Imagens/2_dobra_mobile.jpg';
export const dobra3Desktop = '/Imagens/3_dobra_desk.jpg';
export const dobra3Mobile = '/Imagens/3_dobra_mobile.jpg';
export const dobra4Desktop = '/Imagens/4_dobra_desk.jpg';
export const dobra4Mobile = '/Imagens/4_dobra_mobile.jpg';
export const dobra5Mobile = '/Imagens/5_dobra_mobile.jpg';

// Função helper para verificar se uma imagem existe
export const checkImageExists = (imagePath) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = imagePath;
  });
};

// Objeto com todas as imagens organizadas
export const images = {
  hero: {
    banner: bannerDesktop,
    fallback: dobra1Desktop
  },
  products: {
    vehicles: vehiclesAndBattery,
    fallback: dobra2Desktop
  },
  dobras: {
    desktop: [dobra1Desktop, dobra2Desktop, dobra3Desktop, dobra4Desktop],
    mobile: [dobra1Mobile, dobra2Mobile, dobra3Mobile, dobra4Mobile, dobra5Mobile]
  }
};

export default images;
